import React from 'react'
import {makeStyles, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex'
    },
    icon: {
        marginRight: theme.spacing(1)
    }
}));

function TypographyWithIcon(
    {
        className,
        children,
        Icon,
        ...other
    }) {


    const classes = useStyles();
    return (
        <Typography
            className={clsx(classes.root, className)}
            {...other}
        >
            {!!Icon && <Icon className={classes.icon}/>}
            {children}
        </Typography>
    )
}

TypographyWithIcon.propTypes = {
    classes: PropTypes.any,
    variant: PropTypes.string
}

export default TypographyWithIcon;